import axios from "axios";

// Signing in User
export const userSignInWithEmailAndPassword = (credentials) => {
  return (dispatch) => {
    const { email, password } = credentials;

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/auth/signin`,
      data: {
        email,
        password,
      },
    })
      .then((res) => {
        localStorage.setItem("adminId", res.data.userData.adminId);

        dispatch({
          type: "ADMIN_SIGNIN_SUCCESS",
          isSignedIn: true,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "ADMIN_SIGNIN_ERROR",
          error: error.response
            ? error.response.data.message
            : "Something went wrong",
        });
      });
  };
};

// Signing up User
export const userSignUpWithEmailAndPassword = (credentials) => {
  return (dispatch) => {
    const { name, email, gymSubscriptionCharge, password } = credentials;

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/auth/signup`,
      data: {
        name,
        email,
        gymSubscriptionCharge,
        password,
      },
    })
      .then((res) => {
        localStorage.setItem("adminId", res.data.userData.adminId);

        dispatch({
          type: "ADMIN_SIGNUP_SUCCESS",
          isSignedUp: true,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: "ADMIN_SIGNUP_ERROR",
          error: error.response
            ? error.response.data.message
            : "Something went wrong",
        });
      });
  };
};

// Signing out User
export const signOutUser = () => {
  return (dispatch) => {
    localStorage.removeItem("adminId");
    dispatch({
      type: "ADMIN_SIGNOUT__SUCCESS",
    });
  };
};
